import { Property } from 'csstype';
import { css } from '@emotion/react';

const aspectRatio = (width: number, height: number, objectFit?: Property.ObjectFit) => css`
  position: relative;

  & img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: ${objectFit ?? 'cover'};
    height: 100%;
    width: 100%;
    object-position: center;
    display: block;
  }

  @supports not (aspect-ratio: 1 / 1) {
    padding-top: ${(height / width) * 100}%;
    height: 0;
  }

  @supports (aspect-ratio: 1 / 1) {
    aspect-ratio: ${width} / ${height};

    & > img {
      position: static;
    }
  }
`;

export default aspectRatio;
